import { get } from './apiService';

// One entry per chip in the BE tags registry. `value` is the wire-format
// identifier persisted on dish.<dietary|allergen|origin>Tags; `label` is
// the display string in the current language (resolved server-side from
// ctxData.Language). `preset: true` means the entry is in the curated
// "always show as a chip" set the publish form + filter sheet surface.
//
// The GET /tags endpoint filters to preset entries only, so every
// element on the wire today has preset=true. The field is kept on the
// type for symmetry with a future "include AI-emitted" variant.
export interface TagEntry {
  value: string;
  label: string;
  preset?: boolean;
}

export interface TagsRegistry {
  origins: TagEntry[];
  dietary: TagEntry[];
  allergens: TagEntry[];
}

/** GET /tags — public, no JWT. Server picks the lang from ctxData. */
export async function getTags(): Promise<TagsRegistry> {
  return get<TagsRegistry>('/tags');
}
